import React from "react"

const UserLocationIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
            <path d="M11.9168 8.66667C11.9168 10.2775 10.611 11.5833 9.00016 11.5833C7.38933 11.5833 6.0835 10.2775 6.0835 8.66667C6.0835 7.05584 7.38933 5.75 9.00016 5.75C10.611 5.75 11.9168 7.05584 11.9168 8.66667Z" stroke="#141B34" stroke-width="1.5" />
            <path d="M9 1.16675C13.0588 1.16675 16.5 4.52756 16.5 8.60489C16.5 12.7471 13.0028 15.654 9.7725 17.6307C9.53709 17.7635 9.27087 17.8334 9 17.8334C8.72913 17.8334 8.46291 17.7635 8.2275 17.6307C5.00325 15.6347 1.5 12.7615 1.5 8.60489C1.5 4.52756 4.9412 1.16675 9 1.16675Z" stroke="#2D2D2D" stroke-width="1.5" />
        </svg>
    )
}
export default UserLocationIcon